import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpGroupService } from '../http/http-group.service';
import { HttpUSerService } from '../http/http-user.service';
import { HttpClientService } from '../http/http-client.service';
import { HttpProjectService } from '../http/http-project.service';
import { HttpZoneService } from '../http/http-zone.service';
import { HttpClientTypeService } from '../http/http-client-type.service';
import { HttpCondVentaService } from '../http/http-condvta.service';

@Injectable({
  providedIn: 'root',
})
export class InitAppService {
  private httpGroupService = inject(HttpGroupService);
  private httpZoneService = inject(HttpZoneService);
  private httpClientTypeService = inject(HttpClientTypeService);
  private HttpCondVentaService = inject(HttpCondVentaService);
  private httpUSerService = inject(HttpUSerService);
  private httpCLientService = inject(HttpClientService);
  private httpProjectService = inject(HttpProjectService);

  initServices() {
    //ver si es admin sino no cargar
    this.httpGroupService.init();
    this.httpZoneService.init();
    this.httpClientTypeService.init();
    this.HttpCondVentaService.init();
    this.httpUSerService.findListSeller();
  }
}
